import React, { useState } from 'react';
import InvitationForm from '../../components/InvitationForm';
import styles from './Invitation.module.scss';
import { Confirmation } from '../../components/Confirmation';

const Invitation = () => {
  const [success, setSuccess] = useState(false);
  const [familyFirstName, setFamilyFirstName] = useState('');

  return (
    <>
      {success ? (
        <Confirmation
          title={familyFirstName ? `You’re now a part of ${familyFirstName}’s family!` : `You’re all set!`}
          cta="deepLink"
          parentPage="invite"
        />
      ) : (
        <div className={styles.container}>
          <InvitationForm
            onComplete={(name?: string) => {
              setSuccess(true);
              name && setFamilyFirstName(name);
            }}
          />
        </div>
      )}
    </>
  );
};

export default Invitation;
